import { defineComponent as _defineComponent } from 'vue'
import FormLayout from '@/components/common/FormLayout.vue'
import BatchesList from '@/components/batches/BatchesList.vue'
import { useAddJobsToInvoiceMutation } from '@/api/invoice'
import { computed, ref } from 'vue'
import BatchCreationForm from '@/components/batches/BatchCreationForm.vue'
import { SnackType } from '@/components/vision/SnackBarType'
import { useStore } from 'vuex-composition-helpers'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchSelectionPage',
  props: {
    jobUuid: null,
    hubId: null
  },
  emits: ["job-added-success", "job-added-failure"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'job-added-success', batchId: string)
  (e: 'job-added-failure', message: unknown)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  jobUuid: string
  hubId?: string
}



const hubIdRef = computed(() => props.hubId)



const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const batchesListRef = ref()
const selectedBatchId = ref<string | null | undefined>()
const isSnackbarVisible = ref(false)
const snackbarMessage = ref()
const showCreateBatchForm = ref(false)
const currentSearchQuery = ref('')
const snackbarType = ref(SnackType.ERROR)

const store = useStore()

const {
  mutateAsync: addJobsToBatch,
  isLoading: addingJobsToBatch,
  error: addJobsToBatchError,
} = useAddJobsToInvoiceMutation()

const handleBatchCreatedSuccess = async (data: {
  batchId: string
  batchNumber: string | null
}) => {
  snackbarType.value = SnackType.INFO
  isSnackbarVisible.value = true
  snackbarMessage.value = `Batch "${data.batchNumber}" has been created`
  selectedBatchId.value = data.batchId
  await save()
}

const handleBatchCreatedFailure = async (error: unknown) => {
  snackbarType.value = SnackType.ERROR
  isSnackbarVisible.value = true
  snackbarMessage.value = error
}

const dismiss = () => {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isBatchBottomSheetVisible: false,
  })
}

const onSelect = async (newBatchId: string) => {
  selectedBatchId.value = newBatchId
  await save()
}

async function save() {
  if (!selectedBatchId.value) {
    return
  }
  try {
    store.commit('jobs/SAVING_JOB')
    await addJobsToBatch({
      id: selectedBatchId.value,
      jobIds: [props.jobUuid],
    })
    isSnackbarVisible.value = false
    emits('job-added-success', selectedBatchId.value)
    store.commit('jobs/SAVED_JOB')
    dismiss()
  } catch (err) {
    snackbarType.value = SnackType.ERROR
    isSnackbarVisible.value = true
    snackbarMessage.value = addJobsToBatchError
    emits('job-added-failure', 'addToInvoiceError')
    store.commit('jobs/ERROR_SAVING_JOB')
  }
}

const handleOpenCreateBatchForm = (newSearchQuery: string) => {
  showCreateBatchForm.value = true
  currentSearchQuery.value = newSearchQuery
}

return { __sfc: true,props, hubIdRef, emits, jobBottomSheetStatesStore, batchesListRef, selectedBatchId, isSnackbarVisible, snackbarMessage, showCreateBatchForm, currentSearchQuery, snackbarType, store, addJobsToBatch, addingJobsToBatch, addJobsToBatchError, handleBatchCreatedSuccess, handleBatchCreatedFailure, dismiss, onSelect, save, handleOpenCreateBatchForm, FormLayout, BatchesList, BatchCreationForm }
}

})